var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgArrowUp(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 15,
    viewBox: "0 0 20 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.17806 0.430999C9.2698 0.297758 9.39255 0.188815 9.53575 0.113553C9.67895 0.038291 9.83829 -0.00103283 10.0001 -0.00103283C10.1618 -0.00103283 10.3212 0.038291 10.4644 0.113553C10.6076 0.188815 10.7303 0.297758 10.8221 0.430999L19.8221 13.431C19.9262 13.5809 19.9873 13.7566 19.9987 13.9388C20.0101 14.121 19.9713 14.3029 19.8865 14.4646C19.8018 14.6263 19.6744 14.7618 19.5181 14.8561C19.3618 14.9505 19.1826 15.0003 19.0001 15H1.00006C0.817902 14.9992 0.639397 14.9489 0.483739 14.8542C0.328082 14.7596 0.201162 14.6244 0.116628 14.463C0.0320935 14.3017 -0.0068559 14.1203 0.00396806 13.9385C0.014792 13.7566 0.0749798 13.5812 0.178059 13.431L9.17806 0.430999Z",
    fill: "black"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowUp);
export default __webpack_public_path__ + "static/media/ArrowUp.8690cbcc92563662fa2cbb01203d90be.svg";
export { ForwardRef as ReactComponent };